export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7083d95316c40da80c8c8eafa4f101c6041262a380&name=pushAdClickData!'